import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import {MatDialogModule} from "@angular/material";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { Ng5SliderModule } from 'ng5-slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import {MatRadioModule} from '@angular/material/radio';

import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatListModule } from '@angular/material/list';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerModule } from "ngx-spinner";

import localeFr from '@angular/common/locales/fr';

// videogular
// import { VgCoreModule } from 'videogular2/compiled/core';
// import { VgControlsModule } from 'videogular2/compiled/controls';
// import { VgOverlayPlayModule } from 'videogular2/compiled/overlay-play';
// import { VgBufferingModule } from 'videogular2/compiled/buffering';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { EproComponent } from './components/epro/epro.component';
import { ContactComponent } from './components/contact/contact.component';
import { ContactFormComponent } from './components/contact/contact-form/contact-form.component';
import { GlobalService } from './services/global/global.service';
import { SnackBarComponent } from './shared/snack-bar/snack-bar.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { AnimatedDigitComponent } from './shared/animated-digit/animated-digit.component';
import { DefaultContactPageComponent } from './components/default-contact-page/default-contact-page.component';
import { DialogComponent } from './shared/dialog/dialog.component';
import { PricingExempleComponent } from './components/pricing/pricing-exemple/pricing-exemple.component';
import { registerLocaleData } from '@angular/common';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { PartnershipComponent } from './components/pricing/partnership/partnership.component';
import { WrongRouteComponent } from './components/wrong-route/wrong-route.component';

registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HomeComponent,
    AboutComponent,
    PricingComponent,
    EproComponent,
    ContactComponent,
    ContactFormComponent,
    SnackBarComponent,
    PrivacyPolicyComponent,
    AnimatedDigitComponent,
    DefaultContactPageComponent,
    DialogComponent,
    PricingExempleComponent,
    WelcomeComponent,
    PartnershipComponent,
    WrongRouteComponent,
  ],
  imports: [
    FormsModule,
    MatCarouselModule,
    MatAutocompleteModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatSliderModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatCardModule,
    ReactiveFormsModule,
    Ng5SliderModule,
    MatCheckboxModule,
    MatInputModule,
    MatStepperModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    HttpClientModule,
    MatRadioModule,
    // VgCoreModule,
    // VgControlsModule,
    // VgOverlayPlayModule,
    // VgBufferingModule,
    MatSnackBarModule,
    MatDialogModule,
    NgxSpinnerModule,
    MatSlideToggleModule
  ],
  entryComponents: [
    SnackBarComponent
  ],

  exports: [MatIconModule, MatSliderModule],
  providers: [GlobalService, CookieService, { provide: LOCALE_ID, useValue: 'fr-FR'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
